<template>
  <main class="legal-page">
    <header class="legal-header">
      <router-link to="/" aria-label="Kolobox home">
        <img src="@/assets/images/logo-kolobox.png" alt="Kolobox" />
      </router-link>
      <nav aria-label="Legal documents">
        <router-link to="/terms">Terms of Use</router-link>
        <router-link to="/privacy">Privacy Policy</router-link>
      </nav>
    </header>
    <section class="legal-hero">
      <p>Legal</p>
      <h1>Terms of Use</h1>
      <span>Please read these terms carefully before using Kolobox.</span>
    </section>
    <article class="legal-document">
      <terms-of-use />
    </article>
    <footer class="legal-footer">Kolobox Capital Limited · <a href="mailto:contact@kolobox.ng">contact@kolobox.ng</a></footer>
  </main>
</template>

<script>
import TermsOfUse from "@/components/termsOfUse";

export default {
  name: "TermsPage",
  components: { TermsOfUse },
  created() {
    document.title = "Terms of Use | Kolobox";
  }
};
</script>

<style scoped>
.legal-page { min-height: 100vh; background: #f6f8fb; color: #263238; }
.legal-header { position: sticky; top: 0; z-index: 5; display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 18px max(24px, calc((100% - 1050px) / 2)); background: rgba(255,255,255,.97); border-bottom: 1px solid #e7ebef; box-shadow: 0 1px 8px rgba(27,45,74,.04); }
.legal-header img { width: 145px; height: auto; }
.legal-header nav { display: flex; gap: 20px; }
.legal-header a { color: #35569a; font-weight: 600; }
.legal-header .router-link-exact-active { color: #ec9b2d; }
.legal-hero { padding: 52px 24px; color: #fff; text-align: center; background: linear-gradient(135deg, #1d3e78, #355fa8); }
.legal-hero p { margin: 0 0 4px; color: #f6b650; font-size: 13px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; }
.legal-hero h1 { margin: 0 0 8px; color: #fff; font-size: 38px; font-weight: 700; }
.legal-hero span { color: #e5ecf8; }
.legal-document { max-width: 1050px; margin: 40px auto; padding: 0 20px; }
.legal-document ::v-deep .v-card { overflow: hidden; border-radius: 10px; box-shadow: 0 4px 24px rgba(27, 45, 74, .08); }
.legal-document ::v-deep .v-card__title { padding: 24px 32px; color: #244784; background: #f0f4fa !important; font-size: 23px !important; font-weight: 700; }
.legal-document ::v-deep .v-card__text { padding: 32px; color: #37474f; font-size: 16px; line-height: 1.8; overflow-wrap: anywhere; }
.legal-document ::v-deep .v-card__actions { display: none; }
.legal-footer { padding: 10px 20px 40px; color: #647482; text-align: center; }
.legal-footer a { color: #35569a; }
@media (max-width: 600px) { .legal-header { position: static; align-items: flex-start; flex-direction: column; } .legal-hero { padding: 38px 20px; } .legal-hero h1 { font-size: 31px; } .legal-document { margin-top: 20px; padding: 0 12px; } .legal-document ::v-deep .v-card__text { padding: 22px; font-size: 15px; } }
</style>
